import {generateMetaRegionName} from "../../meta_data/utils/generate_meta_region_name";
import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";

export function getRegionLabel(selectedRegions: ISelectedRegion[]): string {
    if (selectedRegions.length === 0) return "";
    if (selectedRegions.length === 1) return generateMetaRegionName(selectedRegions[0]);

    return selectedRegions.map((region) => region.full_name_reverted).join(", ");
}
import {generateMetaRegionName} from "../../meta_data/utils/generate_meta_region_name";
import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";

export function getRegionLabel(selectedRegions: ISelectedRegion[]): string {
    if (selectedRegions.length === 0) return "";
    if (selectedRegions.length === 1) return generateMetaRegionName(selectedRegions[0]);

    return selectedRegions.map((region) => region.full_name_reverted).join(", ");
}
